(function($){
  // ふとんファクトリーについて fv
  $(document).ready(function() {
    // 初期状態でスクロール禁止
    disableScroll();

    $('.upAnime').each(function(){
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight){
        $(this).addClass("slideAnimeUpDown");
        $(this).children(".upAnimeInner").addClass("slideAnimeDownUp");

        if ($(this).hasClass('-lead02')) {
          $(this).addClass('lead02-delay');
          $(this).children(".upAnimeInner").addClass('lead02-delay');

          setTimeout(function() {
            $('.intro-fv').addClass('fadeOutMask');
          }, 3500);

          // 4.5秒後にスクロールを有効化
          setTimeout(function() {
            enableScroll();
            $('.about-intro').addClass('scrollable');
          }, 4500);
        }
      } else {
        $(this).removeClass("slideAnimeUpDown lead02-delay");
        $(this).children(".upAnimeInner").removeClass("slideAnimeDownUp lead02-delay");
      }
    });
  });

  // スクロール禁止関数
  function disableScroll() {
    $('html, body').css({
      'overflow': 'hidden',
      'height': '100%'
    });
  }

  // スクロール有効化関数
  function enableScroll() {
    $('html, body').css({
      'overflow': '',
      'height': ''
    });
  }
})(jQuery);
